export default function SectionDivider() {
  return (
    <div className="relative w-full h-px overflow-hidden" aria-hidden="true">
      <div className="section-divider-shimmer absolute inset-0" />
    </div>
  );
}
